<div class="h-full flex flex-col overflow-hidden px-4 pb-4 bg-gray-100">
  <div class="relative aligner-between h-[50px]">
    <div class="text-standard-heading font-semibold">
      {{ data.title }}
    </div>
    <button class="close-btn" mat-icon-button mat-dialog-close (click)="close()">
      <fa-icon class="fs-8 text-gray-700" [icon]="['fal', 'times']"></fa-icon>
    </button>
  </div>
  <section class="border-common flex-1 flex flex-col mb-2" *ngFor="let diff of data.diffs; trackBy: trackByFilePath">
    <code *ngIf="!!diff.filePath" class="fs-07 p-2 bg-primary-100">{{ diff.filePath }}</code>
    <div
      *ngIf="!diff.showDiff"
      class="merge-editor h-full w-full"
      y42MonacoEditor
      [options]="{ theme: 'git', readOnly: true }"
      [fileName]="diff.filePath"
      [content]="diff.content1"
    ></div>
    <div
      *ngIf="diff.showDiff"
      class="merge-editor h-full w-full"
      y42MonacoDiffEditor
      [fileName]="diff.filePath"
      [original]="diff.content1"
      [modified]="diff.content2"
    ></div>
  </section>
</div>
